import React, { useState } from "react";
import { triggerSave } from "../core/save/pendingSave";
import { clearStoredUpdateVersion } from "../hooks/useVersionCheck";

export default function UpdateToast() {
    const [saving, setSaving] = useState(false);

    const handleUpdate = async () => {
        setSaving(true);
        try {
            await triggerSave();
        } catch (err) {
            console.error("Erreur lors de la sauvegarde avant mise à jour:", err);
        } finally {
            clearStoredUpdateVersion();
            globalThis.location.reload();
        }
    };

    return (
        <div style={{
            position: "fixed",
            bottom: "24px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#1e293b",
            color: "white",
            borderRadius: "10px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            gap: "16px",
            zIndex: 10000,
            maxWidth: "90vw",
            whiteSpace: "nowrap",
        }}>
            <span style={{ fontSize: "13px" }}>
                Une nouvelle version est disponible.
            </span>
            <button
                onClick={handleUpdate}
                disabled={saving}
                style={{
                    background: saving ? "#475569" : "#3b82f6",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    padding: "6px 14px",
                    fontSize: "13px",
                    fontWeight: 600,
                    cursor: saving ? "not-allowed" : "pointer",
                    flexShrink: 0,
                    transition: "background 0.2s",
                }}
                onMouseEnter={e => { if (!saving) e.currentTarget.style.background = "#2563eb"; }}
                onMouseLeave={e => { if (!saving) e.currentTarget.style.background = "#3b82f6"; }}
            >
                {saving ? "Sauvegarde…" : "Mettre à jour"}
            </button>
        </div>
    );
}
